module.exports = __webpack_public_path__ + "static/media/4341652166522.a0a69665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/4341652166522.jpg
// module id = 778
// module chunks = 2